import { useEffect, useState } from "react";
import * as bie from "react-bootstrap";
import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import PreviewandPrint from "./PreviewandPrint";
import CommonReactTable from "../CommonUtils/CommonReactTable";
import ScrutinyReportExtensionPermission from "./ScrutinyReportExtensionPermission";
import { FaCheck, FaEye, FaMinus, FaTimes } from "react-icons/fa";
import ShiftingScrutinyReport from "./UniversityScreens/ShiftingScrutinyReport";
import ScrutinyReportForNewAc from "./UniversityScreens/ScrutinyReportForNewAc";
import NewCollegeApplPreview from "./NewCollegeApplPreview";
import ChangeOfManagement from "./UniversityScreens/ChangeOfManagement";
import { Field, Form, FormikProvider, useFormik } from "formik";
import DefForSecondInsp from "../UnivDataComponents/DefForSecondInsp";
import { getServiceFullName } from "../CommonUtils/CommonValidations";
import { useSelector } from "react-redux";
import { GetNocServices } from "../Reducers/AffiliationCommonservice";

export default function DeficienciesIdentifiedFlow() {
  const NocServicesOptions = useSelector((state) => state?.commonMastersReducer?.nocservices);

  const [defscrutinyData, defsetScrutinyData] = useState([]);
  const [collCode, setCollCode] = useState("");
  const [instName, setInstName] = useState("");
  const [defdisplayType, defsetDisplayType] = useState("mainReport");
  const [nocType, setNocType] = useState("");
  const defFormik = useFormik({
    initialValues: {
      nocType: "eop",
    },
    onSubmit: () => { },
  });

  function deficiencyGetScrutinyData(type) {
    let url = config?.url?.FAC_URL + "getInspReportPhase2/" + type;

    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        defsetScrutinyData(res?.data?.data);
      } else {
        defsetScrutinyData([]);
      }
    });
  }
  useEffect(() => {
    GetNocServices();
    deficiencyGetScrutinyData(defFormik.values.nocType);
  }, [defFormik.values.nocType]);

  const defscrutinyColumns = [
    {
      id: "slNo",
      header: "Sl.No",
      cell: ({ row }) => row.index + 1,
    },
    {
      id: "ub_name",
      header: "University Name",
      accessorKey: "ub_name",
      Footer: "",
    },
    {
      id: "inst_name",
      header: "College Name-Code",
      accessorKey: "inst_name",
      Footer: "",
    },
    {
      id: "preview",
      header: "College Preview",
      cell: ({ row }) => {
        return (
          <div className="text-center">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm px-2 py-1"
              title="Preview College"
              onClick={() => {
                const code = row.original.inst_name.split("-")[1].trim();
                setCollCode(code);
                setNocType(row.original.noc_type);
                defsetDisplayType("preview");
              }}
            >
              <FaEye size={15} />
            </button>
          </div>
        );
      },
    },
    {
      id: "noc_type",
      header: "NOC Type",
      accessorKey: "noc_type",
      Footer: "",
    },
    {
      id: "action",
      header: "Action",
      cell: ({ row }) => {
        return (
          <div className="text-center">
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={() => {
                const code = row.original.inst_name.split("-")[1].trim();
                const instName = row.original.inst_name;
                defsetDisplayType("srutinyReport");
                setCollCode(code);
                setNocType(row.original.noc_type);
                setInstName(instName);
              }}
            >
              {row.original.noc_type === "eop"
                ? "EOP Inspection"
                : row.original.noc_type === "shifting"
                  ? "Shifting Inspection"
                  : row.original.noc_type === "new_college"
                    ? "New College"
                    : row.original.noc_type === "management"
                      ? "Management Scrutiny Form"
                      : ""}
            </button>
          </div>
        );
      },
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "",
      cell: ({ row }) => {
        const nocType = row.original.noc_type;
        let statusValue = "";

        // Get the status based on noc_type
        if (nocType === "eop") {
          statusValue = row.original.eop_status;
        } else if (nocType === "shifting") {
          statusValue = row.original.shifting_status;
        } else if (nocType === "management") {
          statusValue = row.original.management_status;
        }

        // Determine display text and color
        let displayText = "";
        let colorCode = "";
        let icon = null;

        if (statusValue === "eop_done" || statusValue === "shifting_done" || statusValue === "management_done") {
          displayText = "Already Submitted";
          colorCode = "#15803d";
          icon = <FaCheck />;
        } else if (statusValue === "eop_not_done" || statusValue === "shifting_not_done" || statusValue === "management_not_done") {
          displayText = "Not Submitted";
          colorCode = "#dc2626";
          icon = <FaTimes />;
        } else {
          displayText = "N/A";
          colorCode = "#6b7280";
          icon = <FaMinus />;
        }

        return (
          <span style={{ color: colorCode, fontSize: "13px", fontWeight: 600, display: "inline-flex", alignItems: "center", gap: "4px", }} >
            {icon} {displayText}
          </span>
        );
      },
      Footer: "",
    },
  ];
  return (
    <>
      <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
        <h5 className="mb-3 innerheader-new">
          <span>Deficiencies Scrutiny Details</span>
        </h5>
        <bie.Row className="px-2 pt-3 mb-3 w-100">
          {defdisplayType === "mainReport" ? (
            <>
              <FormikProvider value={defFormik}>
                <Form>
                  <bie.Row>
                    <bie.Col lg={2}>
                      <label
                        className="form-label mb-0"
                        style={{
                          color: "#0f766e",
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Select NOC Type
                      </label>
                    </bie.Col>

                    <bie.Col lg={3}>
                      <select
                        name="nocType"
                        className="form-control"
                        value={defFormik.values.nocType}
                        onChange={(e) => {
                          defFormik.handleChange(e);
                        }}
                      >
                        {/* <option value="eop">EOP</option>
                        <option value="new_college">New College</option>
                        <option value="management">Management Change</option>
                        <option value="shifting">Shifting</option> */}

                        {NocServicesOptions
                          ?.filter((service) => service.is_active)
                          .map((service) => (
                            <option
                              key={service.nos_short_name}
                              value={service.nos_short_name}
                            >
                              {service.full_name}
                            </option>
                          ))}
                      </select>
                    </bie.Col>
                  </bie.Row>
                </Form>
              </FormikProvider>
              {/* // <div className="all-table-content table-responsive"> */}
              {/* <div className="overal-stathead">
                <span>EOP Scrutiny</span>
              </div> */}
              {defscrutinyData.length > 0 ? (
                <div className="table-responsive">
                  <CommonReactTable
                    data={defscrutinyData}
                    columns={defscrutinyColumns}
                    filename="Scrutiny_Report"

                    headerName={` Deficiency Scrutiny Report - ${getServiceFullName(
                      defFormik?.values?.nocType,
                      NocServicesOptions
                    )}`}

                    showPagination={false}
                    showPrint={false}
                    showExcel={true}
                    excelFileName="Scrutiny_Report"
                    showFooter={false}
                  />
                </div>
              ) : (
                <center className="text-danger mt-4 h5">***** No Data Found *****</center>
              )}
            </>
          ) : //  </div>
            defdisplayType === "preview" ? (
              <>
                <div className="text-end">
                  <button className="btn btn-secondary" onClick={() => defsetDisplayType("mainReport")}>
                    Back
                  </button>
                </div>
                {nocType === "new_college" ? <NewCollegeApplPreview collCode={collCode} showHeader={true} /> : <PreviewandPrint collCode={collCode} nocType={nocType} />}
              </>
            ) : defdisplayType === "srutinyReport" ? (
              <>
                <div className="text-end">
                  <button className="btn btn-secondary" onClick={() => defsetDisplayType("mainReport")}>
                    Back
                  </button>
                </div>
                {(nocType === "eop" || nocType === "management") ? (
                  <DefForSecondInsp collCode={collCode} nocType={nocType} instName={instName} />
                ) : nocType === "shifting" ? (
                  <ShiftingScrutinyReport collCode={collCode} nocType={nocType} instName={instName} />
                ) : nocType === "new_college" ? (
                  <ScrutinyReportForNewAc collCode={collCode} nocType={nocType} instName={instName} />
                ) : nocType === "management" ? (
                  <ChangeOfManagement collCode={collCode} nocType={nocType} instName={instName} />
                ) : null}
              </>
            ) : (
              <></>
            )}
        </bie.Row>
      </bie.Container>
    </>
  );
}
